/* global customElements, HTMLElement */

class SlideshowElement extends HTMLElement {
  async connectedCallback () {
    // lazily load swiper modules to keep the initial bundle size small
    const Swiper = (await import('swiper')).default
    const { Keyboard, Navigation, Pagination, EffectFade, A11y } = await import('swiper/modules')

    this.translations = JSON.parse(this.dataset.translations)

    this.$swiper = this.querySelector('.js-slideshow__swiper')
    this.$pagination = this.querySelector('.js-slideshow__pagination')
    this.$next = this.querySelector('.js-slideshow__button--next')
    this.$prev = this.querySelector('.js-slideshow__button--prev')

    this.swiper = new Swiper(this.$swiper, {
      modules: [
        Keyboard,
        Navigation,
        Pagination,
        EffectFade,
        A11y
      ],

      effect: this.effect,
      grabCursor: true,
      slideToClickedSlide: true,
      loopAdditionalSlides: 1,
      keyboard: {
        enabled: true,
        onlyInViewport: true
      },

      a11y: {
        enabled: true,
        firstSlideMessage: this.translations['first-slide'],
        lastSlideMessage: this.translations['last-slide'],
        nextSlideMessage: this.translations['next-slide'],
        prevSlideMessage: this.translations['prev-slide'],
        paginationBulletMessage: this.translations['pagination-bullet'],
        slideLabelMessage: this.translations['slide-label']
      },

      init: false,
      pagination: {
        el: this.$pagination,
        type: this.pagination,
        bulletClass: 'slideshow__bullet',
        bulletActiveClass: 'is-current',
        clickable: true,
        horizontalClass: 'slideshow__pagination--horizontal',
        verticalClass: 'slideshow__pagination--vertical',
        clickableClass: 'is-clickable',
        currentClass: 'is-current',
        hiddenClass: 'is-hidden',
        lockClass: 'is-locked',
        modifierClass: 'is-',
        paginationDisabledClass: 'is-disabled',
        formatFractionCurrent: (number) => {
          const current = number.toString()
          const total = this.swiper.slides.length.toString()

          return current.padStart(total.length, '\u2007')
        }
      },

      navigation: {
        nextEl: this.$next,
        prevEl: this.$prev,
        disabledClass: 'is-disabled',
        lockedClass: 'is-locked',
        hiddenClass: 'is-hidden',
        navigationDisabledClass: 'is-disabled'
      },

      slidesPerView: 'auto',
      spaceBetween: 0,
      sped: 500
    })

    this.swiper.init()
  }

  get loop () {
    return typeof this.dataset.loop !== 'undefined'
  }

  get effect () {
    return this.dataset.effect
  }

  get pagination () {
    return this.dataset.pagination
  }

  get slidesPerView () {
    return this.dataset.slidesPerView
  }
}

customElements.define('x-slideshow', SlideshowElement)
